<template>
  <div v-if="listDatasReady">
    <!-- <crumb-tit>
      <span slot="breadTit">信息分配方式</span>
      <span slot="secondTit">信息分配方式</span>
    </crumb-tit>
    <div class="alloication-tip-t">
      <a-alert
        message="可以自定义信息分配规则，在录入以及审核通过信息时，会根据以下设定的信息分配规则，自动关联应当分配给的信息跟进人员。"
        type="warning"
        show-icon
      />
    </div> -->
    <div class="allocation-op-box clearfix">
      <div class="rule-add-box">
        <a-button
          type="primary"
          @click="addAllocationRule"
        >
          <!-- 添加分配规则 -->
          {{ $t('message["1193"]') }}
        </a-button>
        <add-alloca-dialog
          ref="addAllocaDialog"
          :item-data="{}"
        />
        <a-button
          @click="setAlloRuleModal"
        >
          {{ $t('message["1022"]') }}
        </a-button>
        <set-allociont-modal ref="setAllocationModal" />
      </div>
      <div class="filter-allocation">
        <a-form
          :form="form"
          layout="inline"
          @submit.prevent="saveForm"
        >
          <a-form-item :label="followTitTxt">
            <a-cascader
              v-decorator="['value']"
              :options="currentDevelopDatas2"
              class="dev-choose-list"
              :placeholder="followupplace"
              @change="onChange"
            />
          </a-form-item>
          <a-form-item>
            <a-button
              type="primary"
              html-type="submit"
            >
              {{ $t('message["91"]') }}
            </a-button>
            <a-button
              @click="getDefault"
            >
              {{ $t('message["1625"]') }}
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </div>
    <all-tip-modal
      ref="tipModal"
      :type="tipType"
      @addHanler="addHanler"
      @setHanler="setHanler"
    />
    <div class="allocation-table-list">
      <table-list
        :columns="columns"
        :data="lists"
      />
    </div>
  </div>
</template>
<script>
// import FollowCas from '@/components/pc/config/allocationrule/FollowCas'
import SetAllociontModal from '@/components/pc/config/allocationrule/SetAllociontModal'
import AddAllocaDialog from '@/components/pc/config/allocationrule/AddAllocaDialog'
import TableList from './TableList'
import AllTipModal from '@/components/pc/config/allocationrule/AllTipModal'
import { mapState, mapActions, mapGetters } from 'vuex'
export default {
  components: {
    SetAllociontModal,
    AddAllocaDialog,
    TableList,
    AllTipModal
  },
  provide () {
    return {
      myForm: this.form
    }
  },
  inject: ['reload'],
  data () {
    return {
      form: this.$form.createForm(this),
      data: {
        fieldname: this.$t('message["373"]'),
        child: [],
        fieldkey: 'follow',
        isneeded: 0,
        info: {}
      },
      tipType: 'add'
    }
  },
  computed: {
    ...mapState('config/allocationrule', ['listDatasReady', 'selectedDatas', 'allDatas', 'activeName']),
    ...mapGetters('config/allocationrule', ['lists', 'editSelectedDatas', 'currentDevelopDatas2']),
    columns () {
      return [{
        dataIndex: 'assign_rule_str',
        key: 'assign_rule_str',
        title: this.$t('message["301"]'),
        scopedSlots: { customRender: 'assign_rule_str' }
      }, {
        title: this.$t('message["373"]'),
        dataIndex: 'assign_user_str',
        key: 'assign_user_str',
        scopedSlots: { customRender: 'assign_user_str' }
      }, {
        title: this.$t('message["79"]'),
        key: 'id',
        dadaIndex: 'id',
        scopedSlots: { customRender: 'setruleid' },
        width: 120
      }]
    },
    followTitTxt () {
      return this.$t('message["373"]')
    },
    followupplace () {
      return this.$t('message["863"]')
    }
    // defaultVal () {
    //   const { selectedDatas } = this
    //   let obj = {}
    //   selectedDatas.forEach(item => {
    //     obj[item.fieldkey] = ''
    //     if (item.fieldtype === 'area') {
    //       obj[item.fieldkey] = {}
    //     }
    //   })
    //   return obj
    // }
  },
  watch: {
    activeName (val) {
      if (val) {
        this.form.resetFields()
      }
    }
  },
  async created () {
    await this.getAuthTeamInfo2()
    this.getAllocationDatas(raw => {
      // console.log(raw)
    })
    // const chain = await this.fetchAllocationListDatas()
    // chain.fetch()
  },
  methods: {
    ...mapActions('config/allocationrule', ['fetchAllocationDatas', 'fetchAllocationListDatas', 'getAuthTeamInfo2']),
    saveForm () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const chain = await this.fetchAllocationListDatas()
          chain.params(this.filterData)
            .fetch()
        }
      })
    },
    async setAlloRuleModal () {
      const { selectedDatas } = this
      if (selectedDatas.length > 0) {
        this.tipType = 'set'
        this.$refs.tipModal.changeLimitDialog(true)
      } else {
        this.$refs.setAllocationModal.changeVisible(true)
      }
    },
    async getAllocationDatas (callback) {
      const chain = await this.fetchAllocationDatas()
      chain.onSuccess((raw) => {
        callback && callback(raw)
      }).fetch()
    },
    addAllocationRule () {
      this.getAllocationDatas(raw => {
        const { selectedDatas } = this
        if (selectedDatas.length > 0) {
          const { editSelectedDatas = [] } = this
          editSelectedDatas.forEach(item => {
            if (Object.keys(item).indexOf('defaultValue') > -1) {
              delete item.defaultValue
              // if (item.fieldvalue) {
              //   delete item.fieldvalue
              // }
            }
            if (Object.keys(item).indexOf('fieldvalue') > -1) {
              delete item.fieldvalue
            }
          })
          this.$refs.addAllocaDialog.changeVisible(true)
        } else {
          this.$refs.tipModal.changeLimitDialog(true)
        }
      })
    },
    addHanler () {
      // this.setAlloRuleModal()
      this.$refs.setAllocationModal.changeVisible(true)
    },
    setHanler () {
      this.$refs.setAllocationModal.changeVisible(true)
    },
    async getDefault () {
      // this.data.info = {}
      this.form.resetFields()
      const chain = await this.fetchAllocationListDatas()
      chain.fetch()
      this.reload()
    },
    onChange (val, n) {
      let obj = {}
      let newObj = {}
      if (val.length) {
        n.forEach((item) => {
          const key = item.keyname
          newObj[key] = item.id
          obj = Object.assign(obj, newObj)
        })
      }
      this.filterData = obj
    }
  }
}
</script>
<style lang="scss" scoped>
  .alloication-tip-t {
    margin: 24px 0 16px;
  }
  .allocation-op-box{
    margin-bottom: 24px;
    .rule-add-box {
      float: left;
    }
    .filter-allocation {
      float: right;
      .member-module {
        display:inline-block;
      }
    }
  }
  .allocation-table-list::v-deep {
    margin-bottom: 40px;
    .del-row-item {
      color: #b3b3b3 !important;
    }
  }
</style>
